<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <div class="app flex-row align-items-center">
        <div class="container">
          <b-row class="justify-content-center">
            <b-col md="6">
              <div class="clearfix">
                <h1 class="float-left display-3 mr-4">:)</h1>
                <h4 class="pt-3">Bienvenido a Packapp.</h4>
                <p class="text-muted">
                  El ERP de Producción Especialista en Exportación de Fruta Fresca. Para comenzar, selecciona una opción
                  en el menú, arriba ☝️.
                </p>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ClientTable, Event } from "vue-tables-2";
import VueSocketIO from "vue-socket.io";
import scope from "../utils/scope";
import { db, collection, setDoc, doc } from "../services/firebase";

Vue.use(ClientTable);

export default {
  name: "inicio",
  // created() {
  //   this.$store.dispatch("expireSession");
  // },
  data() {
    return {
      scopes: [],
      data: "",
      modelScale: "",
      optionScales: [],
      img: ""
    };
  },
  sockets: {
    connect: function () {
      console.log("socket connected");
    },
    disconnect() {
      console.log("Desconectado");
    },
    receiveMessage(data) {
      if (this.modelScale == data.numberScale) {
        this.data = data.weight;
      }

      console.log("recibiendo del server  " + data.weight);

      // this.socketMessage = data
    }
  },
  methods: {
    async addItem() {
      const targetMessage = doc(collection(db, "inspections"), "thefirst");
      await setDoc(targetMessage, { likes: 2 }, { merge: true });
    }
  },
  mounted() {
    this.scopes = scope();
    this.$axios
      .get("/api/scale/electronicscale/scale_detail/", {
        params: {
          location_id: 1
        }
      })
      .then((res) => {
        // console.log(res.data.data[0].number);

        var pesas = res.data.data;

        for (let i in pesas) {
          this.optionScales.push({ value: pesas[i].number, text: pesas[i].name });
        }

        var connectionDir = String(pesas[0].connection.address);

        //console.log(connectionDir);

        Vue.use(
          new VueSocketIO({
            debug: true,
            //connection: 'http://localhost:2000',
            //connection: 'http://162.243.14.152:2000/'
            connection: connectionDir
            //options: { path: "/my-app/" } //Optional options
          })
        );
      })
      .catch(function (error) {
        console.log(error.response);
      });

    this.img = this.$store.getters.user.IMAGE;
  }
};
</script>
